import AvatarKonva from "components/avatar-konva";
import { useNavigate } from "react-router-dom";
import { globalStyles } from "styles";
import "./styles.scss";

export default function Step4() {
	const navigate = useNavigate();
	const handleAvatarSaved = () => {
		navigate("/onboarding/5");
	};

	return (
		<div
			id="step4"
			className="relative top-0 left-0 w-full h-full lg:flex lg:flex-col lg:items-center lg:justify-center"
		>
			<div className="w-full h-full lg:h-auto lg:w-auto lg:rounded-xl flex flex-col items-center bg-white p-3 md:p-6 space-y-5">
				<div className="w-full text-center">
					<div className={`leading-none text-center ${globalStyles.header}`}>
						<p>Crea tu avatar</p>
					</div>

					<p>Elige la apariencia que más te guste</p>
				</div>

				<div className="overflow-y-auto relative h-screen md:h-auto w-full">
					<AvatarKonva onSaveSuccess={handleAvatarSaved} />
				</div>
			</div>
		</div>
	);
}
